import CryptoJS from "crypto-js";
const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY;

export const Decryption = (encryptedValue) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
    const decryptedText = bytes?.toString(CryptoJS?.enc?.Utf8);
    return decryptedText ? JSON.parse(decryptedText) : null;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const Encryption = (value) => {
  const encryptedValue = CryptoJS.AES.encrypt(
    JSON.stringify(value),
    SECRET_KEY
  ).toString();
  return encryptedValue;
};

export const paramsDecrypt = (encryptedText) => {
  if(!encryptedText) return "";
  const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_PARAMS_KEY);
  const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_PARAMS_IV);

  const decrypted = CryptoJS.AES.decrypt(
    {
      ciphertext: CryptoJS.enc.Hex.parse(encryptedText),
    },
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};

// function decryptOTP(encryptedText) {}

// const decrypted = decryptOTP(
//   "fdda98205a388adcdfc1597a74400995fcd4d86555d3ffcc5ee5c74105cca59ca263e92952cfddaeb42a9b7c12d661c1ce1551c3c77c3131918422a8d1dfaa1939d5f0dc807c6caa8ed32a5b5167e5385514bc3a6191c3c9a9b004d86ce2c0b1"
// );
// console.log("Decrypted text:", decrypted);
